import script from "./PincodeInputComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PincodeInputComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PincodeInputComponent.vue?vue&type=style&index=0&id=ffca38b0&lang=css"

const __exports__ = script;

export default __exports__